module.exports = __webpack_public_path__ + "images/usermodule/02@2x.gif";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/02@2x.gif
// module id = 1571
// module chunks = 4